(function () {

    "use strict";
    var shiftTemplateUtils;
    var GoodFaithEstimateScheduleDataService = function () {

        var self = this;
        var cachedBrandDetails = {};
        var regularScheduleSettings = {};
        var userAvailabilitiesList = [];

        self.flatData = {
            intervals: [],
            extendedDays: {},
        };

        self.brandLocation = {};
        self.availabilities = [];

        const DAY = 24 * 60 * 60 * 1000;

        self.setActiveBrandLocation = function (location) {
            self.brandLocation = location;
        };

        var doOverlap = function (interval1, interval2) {
            var interval1Start = new Date(interval1.start_time).getTime();
            var interval2Start = new Date(interval2.start_time).getTime();
            var interval1End = new Date(interval1.end_time).getTime();
            var interval2End = new Date(interval2.end_time).getTime();

            if (
                (interval1Start < interval2Start && interval1End < interval2Start) ||
                (interval1End > interval2End && interval1Start > interval2End)
            ) {
                return false;
            }

            return true;
        };

        const prepareExtendedIntervals = (intervals) => {
            const extendedDays = {};
            const nextDayMap = {
                'SUN': 'MON',
                'MON': 'TUE',
                'TUE': 'WED',
                'WED': 'THU',
                'THU': 'FRI',
                'FRI': 'SAT',
                'SAT': 'SUN',
            }

            for (const interval of intervals) {
                const intervalTime = shiftTemplateUtils.getIntervalTime(self.dayOpenHour, {start_time: interval.start_time, end_time: interval.end_time}, true);

                if (intervalTime.end_time > self.dayCloseHour) {
                    const nextDay = nextDayMap[interval.day];
                    const extendedInterval = angular.copy(interval);
                    extendedInterval.isExtendedFromPreviousDay = true;
                    extendedInterval.disableAllSlotActions = true;
                    extendedInterval.extendedDay = nextDay;

                    extendedDays[nextDay] ??= [];
                    extendedDays[nextDay].push(extendedInterval);
                }
            }

            return extendedDays;
        };

        self.getDayOpen = () => {
            return shiftTemplateUtils.secondsToTimeObj(self.dayOpenHour / 1000);
        };

        self.formatShiftInterval = (dayOpen, formattedInterval) => {
            let interval = JSON.parse(JSON.stringify(formattedInterval));
            let dayOpenTime = moment(interval.start_time).hours(dayOpen.hours).minutes(dayOpen.minutes).valueOf();

            interval.start_time = moment(interval.start_time).valueOf();
            interval.end_time = moment(interval.end_time).valueOf();

            if (interval.start_time < dayOpenTime) {
                interval.start_time += DAY;
            }

            if (interval.end_time <= interval.start_time) {
                interval.end_time += DAY;
            }

            let rowTimeZone = new Date(dayOpenTime).getTimezoneOffset();
            let startTimeZone = new Date(interval['start_time']).getTimezoneOffset();
            let endTimeZone = new Date(interval['end_time']).getTimezoneOffset();

            interval.start_time += (startTimeZone - rowTimeZone) * 60 * 1000;
            interval.end_time += (endTimeZone - rowTimeZone) * 60 * 1000;
            interval.id = parseInt(Math.random() * Date.now());

            return interval;
        };

        self.parseData = (gfeData) => {
            let dayOpen = self.getDayOpen();

            for (let i in gfeData['intervals']) {
                let interval = gfeData['intervals'][i];
                interval = self.formatShiftInterval(dayOpen, interval);

                self.flatData['intervals'].push(interval);
            }

            self.flatData.extendedDays = prepareExtendedIntervals(self.flatData.intervals);
        };

        self.deleteInterval = function (interval) {
            for (var i in self.flatData['intervals']) {
                var existingInterval = self.flatData['intervals'][i];

                if (existingInterval.id === interval.id) {
                    self.flatData['intervals'].splice(i, 1);
                    break;
                }
            }

            self.flatData.extendedDays = prepareExtendedIntervals(self.flatData.intervals);
        };

        self.checkIntervalsOverlapping = () => {
            for (const interval of self.flatData.intervals) {
                const intervalTime = shiftTemplateUtils.getIntervalTime(self.dayOpenHour, {start_time: interval.start_time, end_time: interval.end_time}, true);

                const extendedIntervals = self.flatData.extendedDays[interval.day] ?? [];
                for (let extendedInterval of extendedIntervals) {
                    const extendedIntervalTime = shiftTemplateUtils.getIntervalTime(self.dayOpenHour, {start_time: extendedInterval.start_time, end_time: extendedInterval.end_time}, true);
                    extendedIntervalTime.start_time -= DAY;
                    extendedIntervalTime.end_time -= DAY;

                    if (extendedIntervalTime.start_time <= intervalTime.end_time && extendedIntervalTime.end_time > intervalTime.start_time) {
                        return true;
                    }
                }
            }

            return false;
        };

        self.reset = function () {
            self.flatData = {
                intervals: [],
                extendedDays: {},
            };
        };

        self.resetAvailabilities = function () {
           self.availabilities = [];
        }

        self.setRegularScheduleSettings = function (settings) {
            regularScheduleSettings = settings;
        }

        self.getRegularScheduleSettings = function () {
            return regularScheduleSettings;
        }

       var prepareWeekDays = function (effectiveDate, weekStartDay) {
           var weekDays = {};
           var weekStartDate = getWeekStart(effectiveDate, weekStartDay);
            var j = 0;
            while (j < 7) {
                var day = weekStartDate.clone().add(j, 'day');
                var dayKey = day.format('ddd').toUpperCase();
                weekDays[dayKey] = {day: dayKey, date: day};
                j++;
            }
            return weekDays;
        };

        var formattedAvailabilitiesIntervals = function (intervals, startDayOfWeek) {
            var formattedBreaks = [];
            var closeTime = self.businessDay.close_time;
            var openTime = self.businessDay.open_time;

            if (closeTime <= openTime) {
                closeTime += 24 * 60 * 60;
            }

            var weekDays = prepareWeekDays(moment(), startDayOfWeek);

            for (var i in intervals) {
                var interval = angular.copy(intervals[i]);
                var intervalDate = weekDays[interval.day]['date'];
                var startTime;
                var endTime;

                if (interval.is_all_day) {
                    startTime = openTime;
                    endTime = closeTime;
                } else {
                    startTime = (moment(interval.start_time, 'HH:mm').hours() * 60 * 60) + (moment(interval.start_time, 'HH:mm').minutes() * 60);
                    endTime = (moment(interval.end_time, 'HH:mm').hours() * 60 * 60) + (moment(interval.end_time, 'HH:mm').minutes() * 60);
                }

                var IntervalStartTime = shiftTemplateUtils.secondsToTimeObj(startTime);

                var IntervalEndTime = shiftTemplateUtils.secondsToTimeObj(endTime);
                interval.start_time = intervalDate.clone().hours(IntervalStartTime.hours).minutes(IntervalStartTime.minutes).seconds(0).format('MMM DD, YYYY HH:mm');
                interval.end_time = intervalDate.clone().hours(IntervalEndTime.hours).minutes(IntervalEndTime.minutes).seconds(0).format('MMM DD, YYYY HH:mm');
                formattedBreaks.push(interval);
            }

            return formattedBreaks;
        };

        self.getEffectiveAvailabilityRequest = function (effectiveDay, startDayOfWeek) {
            self.requsetsInsideInterval = [];
            self.availabilities = [];
            var dayOpen = shiftTemplateUtils.secondsToTimeObj(self.dayOpenHour / 1000);
            var weekDays = prepareWeekDays(moment(effectiveDay), startDayOfWeek);

            for (var i in userAvailabilitiesList) {
                var startDateOfWeek = Object.values(weekDays)[0].date;
                var endDateOfWeek = Object.values(weekDays)[6].date;

                if (moment(userAvailabilitiesList[i].start_date).isSameOrAfter(endDateOfWeek) ||
                    (userAvailabilitiesList[i].end_date && moment(userAvailabilitiesList[i].end_date).isBefore(startDateOfWeek))) {
                    continue;
                }
                self.requsetsInsideInterval.push(userAvailabilitiesList[i]);
            }

            if (self.requsetsInsideInterval.length) {
                self.requsetsInsideInterval.sort(function(a, b) {
                    return moment(a.start_time).format('YYYYMMDD') - moment(b.start_time).format('YYYYMMDD')
                });
                var intervals = formattedAvailabilitiesIntervals(self.requsetsInsideInterval[0]['intervals'], startDayOfWeek);

                for (var i in intervals) {
                    var interval = intervals[i];
                    interval.status = 'APPROVED';
                    interval.type = interval.state === 'AVAILABLE' ? 'WORKABLE' : 'AVAILABILITY';
                    var dayOpenTime = moment(interval.start_time).hours(dayOpen.hours).minutes(dayOpen.minutes).valueOf();
                    interval.start_time = moment(interval.start_time).valueOf();
                    interval.end_time = moment(interval.end_time).valueOf();

                    if (interval.start_time < dayOpenTime) {
                        interval.start_time += DAY;
                    }

                    if (interval.end_time <= interval.start_time) {
                        interval.end_time += DAY;
                    }

                    var rowTimeZone = new Date(dayOpenTime).getTimezoneOffset();
                    var startTimeZone = new Date(interval['start_time']).getTimezoneOffset();
                    var endTimeZone = new Date(interval['end_time']).getTimezoneOffset();

                    interval.start_time += (startTimeZone - rowTimeZone) * 60 * 1000;
                    interval.end_time += (endTimeZone - rowTimeZone) * 60 * 1000;
                    self.availabilities.push(interval);
                }
            }
        };

        self.parseAvailabilities = function (userAvailabilities) {
            userAvailabilitiesList = [];
            for (var i in userAvailabilities) {
                var userAvailability = angular.copy(userAvailabilities[i]);

                if (userAvailability && userAvailability['weeks'] && userAvailability['weeks'].length) {
                    var availabilityData = userAvailability['weeks'][0];
                    var pushedObj = {start_date: userAvailability.start_date, end_date: userAvailability.end_date, intervals: availabilityData['intervals'], id: userAvailability.id};
                    userAvailabilitiesList.push(pushedObj);
                }
            }
        };

        self.mergeOverlaps = function () {
            for (var i = self.flatData['intervals'].length - 1; i >= 0; i--) {
                var interval1 = self.flatData['intervals'][i];

                for (var j = i + 1; j < self.flatData['intervals'].length; j++) {
                    var interval2 = self.flatData['intervals'][j];

                    if (doOverlap(interval1, interval2) && interval1.day === interval2.day) {
                        self.flatData['intervals'][j].start_time = interval1.start_time < interval2.start_time? interval1.start_time: interval2.start_time;
                        self.flatData['intervals'][j].end_time = interval1.end_time > interval2.end_time? interval1.end_time: interval2.end_time;
                        self.flatData['intervals'].splice(i, 1);
                        break;
                    }

                }
            }

            self.flatData.extendedDays = prepareExtendedIntervals(self.flatData.intervals);
        };

        self.checkWhichIntervalOverlapsWithPermanentShift = function (shift, intervals) {
            for (var i = 0; i < intervals.length; i++) {
                if (doOverlap(shift, intervals[i]) && shift.day === intervals[i].day) {
                    return intervals[i];
                }
            }
            return undefined;
        }

        self.addInterval = function (interval, dontMerge) {
            interval.start_time = moment(interval.start_time).valueOf();
            interval.end_time = moment(interval.end_time).valueOf();

            if (interval.end_time <= interval.start_time) {
                interval.end_time += DAY;
            }

            interval.id = interval.id || Date.now();

            self.flatData['intervals'].push(interval);

            if (!dontMerge) {
                self.mergeOverlaps();
            }

            self.flatData.extendedDays = prepareExtendedIntervals(self.flatData.intervals);
        };

        const findMatchedBusinessDay =  (selectedDay, businessDays) => {
            var selectedDayTime = new Date(selectedDay).getTime();
            for (var i in businessDays) {
                var businessDayTime = moment(businessDays[i].start_date, "YYYY-MM-DD").valueOf();

                if (selectedDayTime >= businessDayTime) {
                    return businessDays[i];
                }
            }
        };

        self.setBusinessDay = (selectedDay, businessDays)  => {
            self.businessDays = businessDays || self.businessDays;
            self.businessDay = findMatchedBusinessDay(selectedDay, self.businessDays);
            let normalizedBusinessDay = getNormalizedBusinessDay(self.businessDay);
            self.dayOpenHour = normalizedBusinessDay.open_time;
            self.dayCloseHour = normalizedBusinessDay.close_time;
            self.dayCloseHourExtension = normalizedBusinessDay.close_time_extension;
        };

        const getNormalizedBusinessDay = (businessDay) => {
            // Convert times from seconds to milliseconds
            const dayOpenHour = businessDay?.open_time * 1000 || 0;
            let dayCloseHour = businessDay?.close_time * 1000 || 0;
            const dayCloseHourExtension = businessDay?.close_time_extension * 1000 || 0;

            if (dayCloseHour <= dayOpenHour) {
                dayCloseHour += DAY; // One day shift in milliseconds
            }

            return {
                open_time: dayOpenHour,
                close_time: dayCloseHour,
                close_time_extension: dayCloseHourExtension,
            };
        };


        self.getNormalizedBusinessDayForSelectedDate = (day, businessDays) => {
            const businessDay = findMatchedBusinessDay(day, businessDays);
            const normalizedBusinessDay = getNormalizedBusinessDay(businessDay);
            return {
                open_time: normalizedBusinessDay.open_time,
                close_time: normalizedBusinessDay.close_time,
                close_time_extension: normalizedBusinessDay.close_time_extension,
                business_day: businessDay
            }
        }
        
        self.getBrandDetails = function (brandId) {
            var defer = $q.defer();

            if (cachedBrandDetails[brandId]) {
                defer.resolve(angular.copy(cachedBrandDetails[brandId]));
            } else {
                ProfileAPI.getBrandProfile(brandId)
                    .then(function (brand) {
                        cachedBrandDetails[brandId] = {id: brand.id, name: brand.name};
                        if (brand.location && brand.location[0]) {
                            cachedBrandDetails[brandId]['address'] = brand.location[0]['formatted_address']
                        }
                        defer.resolve(angular.copy(cachedBrandDetails[brandId]));
                    })
                    .catch(function (err) {
                        defer.reject(err);
                    });
            }

            return defer.promise;
        };

        self.setScheduleBrandId = function (brandId) {
            self.brandId = brandId;
        };
    };

    angular
        .module("harriApp")
        .service('GoodFaithEstimateScheduleDataService', ['ShiftTemplateUtils',
            function (ShiftTemplateUtils) {
                shiftTemplateUtils = ShiftTemplateUtils;
            return function () {
                return new GoodFaithEstimateScheduleDataService();
            }
        }
    ]);

})();